const httpFeedbackModule = {
    state() {
        return {
            active: false,
            variant: null,
            status: null,
            title: '',
            description: '',
            messages: [],
            source: null,
        };
    },

    mutations: {
        showHttpFeedback(state, payload) {
            state.active = true;
            state.variant = payload.variant ?? null;
            state.status = payload.status ?? null;
            state.title = payload.title ?? '';
            state.description = payload.description ?? '';
            state.messages = Array.isArray(payload.messages) ? [...payload.messages] : [];
            state.source = payload.source ?? null;
        },

        clearHttpFeedback(state) {
            state.active = false;
            state.variant = null;
            state.status = null;
            state.title = '';
            state.description = '';
            state.messages = [];
            state.source = null;
        },
    },

    actions: {
        showHttpFeedback({ commit }, payload) {
            commit('showHttpFeedback', payload);
        },

        clearHttpFeedback({ commit }) {
            commit('clearHttpFeedback');
        },
    },

    getters: {
        httpFeedbackActive(state) {
            return state.active;
        },

        httpFeedback(state) {
            return {
                active: state.active,
                variant: state.variant,
                status: state.status,
                title: state.title,
                description: state.description,
                messages: state.messages,
                source: state.source,
            };
        },
    },
};

export default httpFeedbackModule;
